import React, { useEffect, useRef } from 'react';
import './TerminalHero.css';

const sequence = [
  { type: 'cmd', prompt: 'affan@aws',   cmd: 'terraform apply -auto-approve' },
  { type: 'out', text: 'Plan: 3 to add, 0 to change',    cls: '#8b949e' },
  { type: 'out', text: 'aws_instance.ec2    ✔ created',   cls: '#56d364' },
  { type: 'out', text: 'aws_nlb.main        ✔ created',   cls: '#56d364' },
  { type: 'out', text: 'route53_record.mail ✔ created',   cls: '#56d364' },
  { type: 'out', text: 'Apply complete! Resources: 3',    cls: '#39c5cf' },
  { type: 'gap' },
  { type: 'cmd', prompt: 'affan@aws',   cmd: 'gh workflow run deploy.yml' },
  { type: 'out', text: 'Triggered CI/CD pipeline',        cls: '#8b949e' },
  { type: 'out', text: '✓ Docker build passed',           cls: '#56d364' },
  { type: 'out', text: '✓ Pushed to ECR',                 cls: '#56d364' },
  { type: 'out', text: '✓ ECS service updated',           cls: '#56d364' },
  { type: 'gap' },
  { type: 'cmd', prompt: 'affan@azure', cmd: 'az monitor alert list' },
  { type: 'out', text: 'Malware detection  [active]',     cls: '#e3b341' },
  { type: 'out', text: 'VM heartbeat       [active]',     cls: '#56d364' },
  { type: 'out', text: 'Entra ID alerts    [active]',     cls: '#56d364' },
  { type: 'gap' },
  { type: 'cursor', prompt: 'affan@aws' },
];

const delays = [0,700,1100,1500,1900,2400,2900,3200,3900,4400,4900,5400,5900,6200,6900,7300,7700,8100,8400];
const MAX_LINES = 18;

const TerminalHero = () => {
  const outputRef = useRef(null);
  const linesRef  = useRef([]);
  const timersRef = useRef([]);

  const addLine = (html) => {
    const el = document.createElement('div');
    el.innerHTML = html;
    el.style.whiteSpace = 'pre';
    outputRef.current.appendChild(el);
    linesRef.current.push(el);
    if (linesRef.current.length > MAX_LINES) {
      linesRef.current[0].remove();
      linesRef.current.shift();
    }
  };

  const renderStep = (s) => {
    if (s.type === 'cmd') {
      addLine(`<span class="term-prompt">${s.prompt} $</span> <span class="term-cmd">${s.cmd}</span>`);
    } else if (s.type === 'out') {
      addLine(`<span style="color:${s.cls}">${s.text}</span>`);
    } else if (s.type === 'gap') {
      addLine('');
    } else if (s.type === 'cursor') {
      addLine(`<span class="term-prompt">${s.prompt} $</span> <span class="term-cursor"></span>`);
    }
  };

  const runSequence = (startIndex) => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [];

    for (let i = startIndex; i < sequence.length; i++) {
      const t = setTimeout(() => {
        if (!outputRef.current) return;
        renderStep(sequence[i]);
        if (i === sequence.length - 1) {
          const resetTimer = setTimeout(() => {
            if (!outputRef.current) return;
            outputRef.current.innerHTML = '';
            linesRef.current = [];
            runSequence(0);
          }, 2500);
          timersRef.current.push(resetTimer);
        }
      }, delays[i] - delays[startIndex]);
      timersRef.current.push(t);
    }
  };

  useEffect(() => {
    runSequence(0);
    return () => timersRef.current.forEach(clearTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="terminal-hero">
      {/* Title bar */}
      <div className="terminal-titlebar">
        <span className="terminal-dot terminal-dot--red" />
        <span className="terminal-dot terminal-dot--yellow" />
        <span className="terminal-dot terminal-dot--green" />
        <span className="terminal-title">affan@devops ~ zsh</span>
      </div>
      {/* Output */}
      <div className="terminal-output" ref={outputRef} />
    </div>
  );
};

export default TerminalHero;
